import { supabase } from '../lib/supabase';

export interface Official {
  id: string;
  name: string;
  certification_level?: string;
  avatar?: string;
}

export const officialService = {
  // Get all officials for dropdown
  async getOfficials(): Promise<Official[]> {
    try {
      const { data, error } = await supabase
        .from('officials')
        .select('id, name, certification_level, avatar')
        .eq('active', true)
        .order('name');

      if (error) {
        console.error('Error fetching officials:', error);
        return [];
      }

      return data || [];
    } catch (error) {
      console.error('Error in getOfficials:', error);
      return [];
    }
  }
};
